<script lang="ts" setup>
  interface Props {
    file: string
  }

  const re = /(?:\.([^.]+))?$/

  const props = defineProps<Props>()

  const extension = computed<string>(() => {
    const output = re.exec(props.file)
    return Array.isArray(output) && output.length >= 1 ? output[1] : 'file'
  })
</script>

<template>
  <a class="c-file-item u-reset" :href="file" rel="noopener noreferrer" target="_blank">
    <div class="c-file-item__box">
      <div class="c-file-item__label">
        {{ extension }}
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
  @use 'sass:math';
  @use '@nirazul/scss-utils' as utils;
  @use '/assets/scss/base/mq' as mq;
  @use '/assets/scss/util/transition' as trs;
  @use '/assets/scss/util/color/color' as col;
  @use '/assets/scss/util/anaglyph/anaglyph' as anaglyph;
  @use '/assets/scss/base/typography/typography' as type;
  @use '/assets/scss/structure/btn/btn-util-anaglyph' as util-anaglyph;

  $o: 2px;
  $w: 100px;
  $ratio: 1.4142; // DIN A4

  .c-file-item {
    margin: $o;

    @include utils.has-focus {
      .c-file-item__box {
        @include anaglyph.with-shadow-apply(mono, $o * 2, $o * 2, 0, 0, col.$brand-red);
        @include util-anaglyph.move-helper($o * 2, $o * 2);
        transform: translate(-$o, -$o);
      }

      .c-file-item__label {
        background-color: col.$brand-red;
      }
    }
  }

  .c-file-item__box {
    @include anaglyph.with-shadow-apply(mono, $o, $o, 0, 0, col.$brand-red);
    position: relative;
    width: $w;
    padding-top: $w * $ratio;
    background-color: col.$monochrome-white;
    transition: box-shadow trs.$default, transform trs.$default, background-color trs.$default;
    will-change: transform;

    @include util-anaglyph.add-helper($o, 0, 0) {
      transition: transform trs.$default;
    }

    @include mq.media('<=sm') {
      padding-top: math.div($w, $ratio);
    }
  }

  .c-file-item__label {
    @include type.button-small;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    text-transform: uppercase;
    padding: 3px 6px 4px;
    margin: 8px;
    border-radius: 2px;
    color: col.$monochrome-white;
    background-color: col.$variant-red-dark;
    transition: background-color trs.$default;
  }
</style>
